import { gql } from 'apollo-boost';

export const LOG_PAGE_VIEW = gql`
    mutation logPageView($pageUrl: String!, $pageType: String) {
        logPageView(input: { pageUrl: $pageUrl, pageType: $pageType }) {
            success
        }
    }
`;